/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type BurnDownReportEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const burnDownReportEntrypoint: EntryPoint<BurnDownReportEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<BurnDownReportEntrypointComponent>(
			/* webpackChunkName: "async-next-gen-reports-burn-down-entrypoint" */ './index.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
